import React from "react";
import { Accordion } from "react-bootstrap";
import { FaqAccordionItemCss } from "./FaqAccordionItemCss";
import "./FaqAccordionItem.css";

interface FaqAccordionItemI {
  title: string;
  description: string;
  index: number;
}

const FaqAccordionItem = (item: FaqAccordionItemI) => {
  return (
    <Accordion.Item
      eventKey={String(item.index)}
      style={FaqAccordionItemCss.accordionItem}
    >
      <Accordion.Header className={"faq-accordion"}>
        {item.title}
      </Accordion.Header>
      <Accordion.Collapse
        style={{ background: "red" }}
        eventKey={String(item.index)}
      >
        <Accordion.Body style={FaqAccordionItemCss.body}>
          <span dangerouslySetInnerHTML={{ __html: item.description }}></span>
        </Accordion.Body>
      </Accordion.Collapse>
    </Accordion.Item>
  );
};

export default FaqAccordionItem;
